import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MdAttachMoney from 'react-icons/lib/md/attach-money';
import { MdDone } from 'react-icons/lib/md';
import { fetchBudgets } from '../../actions/project_actions';
import { formatMoney } from '../../utils/budget';

const sumColumnForRows = (list) => (column) => {
  const sum = list.reduce((sum, item) => sum + item[column], 0);
  return formatMoney(sum);
}


const BudgetTable = ({ rows }) => {
  const sumColumn = sumColumnForRows(rows);
  return (
    <table>
      <thead>
        <tr>
          <th>Type</th>
          <th>Phase</th>
          <th>Plan</th>
          <th>Commitments</th>
          <th>Actual Exp</th>
          <th>Available</th>
        </tr>
      </thead>
      <tbody>
      { rows.map(row =>
        <tr key={`budget-${row.id}`}>
          <td>{row.phaseType}</td>
          <td>{row.pObject}</td>
          <td>{ formatMoney(row.plannedAmount)    }</td>
          <td>{ formatMoney(row.committedAmount)  }</td>
          <td>{ formatMoney(row.liquidatedAmount) }</td>
          <td>{ formatMoney(row.availableAmount)  }</td>
        </tr>
      )}
        <tr className="totals">
          <td></td>
          <td></td>
          <td>{ sumColumn('plannedAmount')    }</td>
          <td>{ sumColumn('committedAmount')  }</td>
          <td>{ sumColumn('liquidatedAmount') }</td>
          <td>{ sumColumn('availableAmount')  }</td>
        </tr>
      </tbody>
    </table>
  );
}

BudgetTable.propTypes = {
  rows: PropTypes.array.isRequired
}

class NewBudget extends Component {
  // static PropTypes = {
  //   fetch: PropTypes.bool,
  //   projectId: PropTypes.string.isRequired,
  //   fetchBudgets: PropTypes.func.isRequired,
  //   budgets: PropTypes.array.isRequired,
  // }

  UNSAFE_componentWillMount () {
    if (this.props.fetch) this.props.fetchBudgets(this.props.projectId);
  }

  render () {
    const { budgets } = this.props;
    const toShow = budgets.filter(b => b.budget.length > 0);

    return (
      <div id="budget" className="row-wide project-budget">
        <div className="col s12">
        
          <h4 className="bar-bottom">
            <span><MdAttachMoney size={20} /></span> Budget
          </h4>
        </div>
        <div className="col s12">
          { toShow.length === 0
            ? <p>This project has no budgets entries yet.</p>
            : null }
          { toShow.map(({ fmsid, budget }) =>
            <div key={fmsid}>
              <h6>{fmsid}</h6>
              
              <span className="margin-right-0"></span>
              { ( budget.filter(b=>b.isfhwa ==='1').length > 0) ?
              <div className="flag-custom">
                <span className="align-bottom margin-right-0325"><MdDone size={20} color="#008000" /></span>
                <strong className="align-middle label-color font-size-875">FHWA Funded</strong>
              </div> :null }
              <div className="table-wrap">
                <BudgetTable rows={budget} />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

NewBudget.propTypes = {
  fetch: PropTypes.bool,
  projectId: PropTypes.string.isRequired,
  fetchBudgets: PropTypes.func.isRequired,
  budgets: PropTypes.array.isRequired
};

function mapStateToProps (state, ownProps) {
  debugger;
  return {
    projectId: ownProps.projectId,
    budgets: state.projectsStore.budgets,
  };
}

export default connect(mapStateToProps, {fetchBudgets})(NewBudget);